const PromotionsNews = {
  path: "",
  name: "",
  redirect: "/promotionnews",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/promotionnews",
      redirect: "/promotionnews",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "News/Promotion News",
      meta: {
        requiresAuth: true,
        activeUrl: "/promotionnews",
        parent: "promotionnews",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/promotionNews/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/promotionnews",
            parent: "promotionnews",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "News/Promotion News Detail",
          component: () => import("@/views/pages/promotionNews/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/promotionnews",
            parent: "promotionnews",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default PromotionsNews;
